import { Box, HStack, InputProps, Text } from '@chakra-ui/react';
import { BaseFilterOptionProps } from '../types/FilterOption';

export const DefaultOption = ({
  label,
  onClick,
  placeholderColor,
}: BaseFilterOptionProps & { placeholderColor?: InputProps['color'] }): React.ReactElement => {
  return (
    <Box p="s" cursor="pointer" _hover={{ bg: 'grey.100' }} onClick={onClick}>
      <HStack justify="space-between">
        <Text
          textStyle="body.m.medium"
          fontWeight="regular"
          color={placeholderColor || 'text.primary'}
        >
          {label}
        </Text>
      </HStack>
    </Box>
  );
};
